/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SavedPriceInfo } from './SavedPriceInfo';
import {
    SavedPriceInfoFromJSON,
    SavedPriceInfoFromJSONTyped,
    SavedPriceInfoToJSON,
    SavedPriceInfoToJSONTyped,
} from './SavedPriceInfo';

/**
 * 
 * @export
 * @interface SaveCreatePriceResponse
 */
export interface SaveCreatePriceResponse {
    /**
     * 
     * @type {number}
     * @memberof SaveCreatePriceResponse
     */
    readonly savedCount?: number;
    /**
     * 
     * @type {Array<SavedPriceInfo>}
     * @memberof SaveCreatePriceResponse
     */
    savedPrices: Array<SavedPriceInfo> | null;
}

/**
 * Check if a given object implements the SaveCreatePriceResponse interface.
 */
export function instanceOfSaveCreatePriceResponse(value: object): value is SaveCreatePriceResponse {
    if (!('savedPrices' in value) || value['savedPrices'] === undefined) return false;
    return true;
}

export function SaveCreatePriceResponseFromJSON(json: any): SaveCreatePriceResponse {
    return SaveCreatePriceResponseFromJSONTyped(json, false);
}

export function SaveCreatePriceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCreatePriceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'savedCount': json['savedCount'] == null ? undefined : json['savedCount'],
        'savedPrices': (json['savedPrices'] == null ? null : (json['savedPrices'] as Array<any>).map(SavedPriceInfoFromJSON)),
    };
}

export function SaveCreatePriceResponseToJSON(json: any): SaveCreatePriceResponse {
    return SaveCreatePriceResponseToJSONTyped(json, false);
}

export function SaveCreatePriceResponseToJSONTyped(value?: Omit<SaveCreatePriceResponse, 'savedCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'savedPrices': (value['savedPrices'] == null ? null : (value['savedPrices'] as Array<any>).map(SavedPriceInfoToJSON)),
    };
}

